module.exports = __webpack_public_path__ + "img/BackgroundRemoval03.a0ea8475.png";